import React from 'react'

const Subfourcomp = (props) => {
    return (
        <div>
        <div className="newrelativeclass">
             <div className="newimgsrc" ><img src={props.imgsrc} className="img2c"></img></div>
                    <div className="boxtitle2">
                        <div>
                            <div className="cfournewtitle">Beauty</div>
                            <div className="cfourtwotagline">Lorem ipsum dolor sit, amet sit sit consectetur adipisicing elit. Laudantium.</div>
                            <div className="cfourborder"></div>
                            <div className="cfourdateandname"> mellis hover 21 june 2021</div>
                            <br></br>
                        </div>
                    </div>
        </div>
        </div>
    )
}

export default Subfourcomp
